export default __webpack_public_path__ + "static/media/3d-banner-collage.401af138.jpg";